
import moment from "moment";

/**
 *
 * @param {*} startAt
 * @returns
 */
export const defineExpectedEndAt = (startAt, expectedDuration) => {
    return moment(startAt).add(expectedDuration, "days");
};
